<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-user"></i> 员工信息
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 员工基本信息 -->
      <div class="info-section">
        <div class="section-title">
          <i class="el-icon-info"></i>
          <span>人员信息</span>
        </div>
        <el-descriptions :column="3" border size="small" class="info-descriptions">
          <el-descriptions-item label="员工姓名">
            <span class="name-text">{{ employeeInfo.name_cn || '-' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="性别">
            <el-tag :type="employeeInfo.sex == 1 ? 'success' : 'warning'" size="small" effect="plain">
              {{ employeeInfo.sex == 1 ? '男' : (employeeInfo.sex == 0 ? '女' : '-') }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="身份证号">
            <span class="id-card">{{ employeeInfo.id_code || '-' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="联系电话">
            <el-tag size="small" type="primary" effect="plain">
              <i class="el-icon-phone"></i> {{ employeeInfo.mobile || '-' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="所属部门">
            <span class="dept-name">{{ employeeInfo.department_name || '-' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="工作状态">
            <el-tag :type="employeeInfo.work_status == 1 ? 'success' : 'info'" size="small">
              {{ employeeInfo.work_status == 1 ? '在岗' : (employeeInfo.work_status == 0 ? '离岗' : '-') }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="是否在建">
            <el-tag :type="employeeInfo.status == 1 ? 'success' : 'info'" size="small" effect="plain">
              {{ employeeInfo.status == 1 ? '是' : (employeeInfo.status == 0 ? '否' : '-') }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="执业时间">
            <span class="time-text">{{ employeeInfo.work_start_time || '-' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="社保缴纳时间">
            <span class="time-text">{{ employeeInfo.insurance_start_time || '-' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="费用缴纳单位">
            <span>{{ employeeInfo.insurance_unit_name || '-' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="社保状况">
            <span>{{ employeeInfo.insurance_status || '-' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="创建人">
            <span>{{ employeeInfo.creator_name || '-' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="创建时间">
            <span class="time-text">{{ employeeInfo.add_time | dateFormat }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 证书信息 -->
      <div class="info-section">
        <div class="section-title">
          <i class="el-icon-medal"></i>
          <span>证书信息</span>
          <el-button 
            type="primary" 
            size="small" 
            @click="addCertificate" 
            icon="el-icon-plus"
            class="add-btn"
          >
            添加证书
          </el-button>
        </div>
        
        <div class="table-wrapper">
          <el-table
            :data="creditList"
            stripe
            border
            size="medium"
            :header-cell-style="headerCellStyle"
            v-loading="certLoading"
            element-loading-text="加载中..."
          >
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column label="证书名称" prop="cert_name" min-width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="证书编号" prop="cert_no" min-width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="证书注册号" prop="register_no" width="150" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="证书专业" prop="major" width="120" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="取得时间" prop="obtain_time" width="120" align="center">
              <template slot-scope="scope">
                <span class="time-text">{{ scope.row.obtain_time | dateFormat }}</span>
              </template>
            </el-table-column>
            <el-table-column label="到期时间" prop="expire_time" width="120" align="center">
              <template slot-scope="scope">
                <span class="time-text" :class="{ 'expired': isExpired(scope.row.expire_time) }">
                  {{ scope.row.expire_time | dateFormat }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="证书预览" width="100" align="center">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small"
                  @click="previewCert(scope.row)"
                  :disabled="!scope.row.file_url"
                >
                  <i class="el-icon-view"></i> 预览
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="证书下载" width="100" align="center">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small"
                  @click="downloadCert(scope.row)"
                  :disabled="!scope.row.file_url"
                >
                  <i class="el-icon-download"></i> 下载
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 空状态 -->
        <div v-if="creditList.length === 0 && !certLoading" class="empty-state">
          <i class="el-icon-medal"></i>
          <p>暂无证书信息</p>
          <el-button type="primary" size="small" @click="addCertificate">立即添加</el-button>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="form-actions">
        <el-button @click="goBack" icon="el-icon-back" size="medium">返回</el-button>
        <el-button type="primary" @click="goEdit" icon="el-icon-edit" size="medium">编辑</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'proxyEmployeeInfo',
  data() {
    return {
      // 员工信息
      employeeInfo: {
        name_cn: '',
        sex: '',
        id_code: '',
        mobile: '',
        department_name: '',
        work_status: '',
        status: '',
        work_start_time: '',
        insurance_start_time: '',
        insurance_unit_name: '',
        insurance_status: '',
        creator_name: '',
        add_time: ''
      },
      
      // 证书列表
      creditList: [],
      certLoading: false,
      
      // 员工ID
      employeeId: null
    }
  },
  mounted() {
    const id = this.$route.query.id
    if (id && !isNaN(id) && id > 0) {
      this.employeeId = id
      this.getEmployeeInfo()
      this.getCertList()
    } else {
      this.$message.error('员工ID不存在')
      this.goBack()
    }
  },
  filters: {
    dateFormat(time) {
      if (!time) return ''
      return moment(time * 1000).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    // 表格样式配置
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    
    // 判断是否过期
    isExpired(expireTime) {
      if (!expireTime) return false
      const expireDate = moment(expireTime * 1000)
      return expireDate.isBefore(moment())
    },
    
    // 获取员工信息
    getEmployeeInfo() {
      const param = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        id: this.employeeId
      }
      this.$axios.proxyEmployeeOne(param).then((res) => {
        if (res.code == 200) {
          this.employeeInfo = res.data
        }
      }).catch(error => {
        console.error('获取员工信息失败:', error)
        this.$message.error('获取员工信息失败')
      })
    },
    
    // 获取证书列表
    getCertList() {
      this.certLoading = true
      const param = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        employee_id: this.employeeId
      }
      this.$axios.employeeCertList(param).then((res) => {
        this.certLoading = false
        if (res.code == 200) {
          this.creditList = res.data || []
        }
      }).catch(error => {
        this.certLoading = false
        console.error('获取证书列表失败:', error)
      })
    },
    
    // 添加证书
    addCertificate() {
      this.$router.push({
        path: '/employeeCertificateForm',
        query: { employee_id: this.employeeId }
      })
    },
    
    // 预览证书
    previewCert(row) {
      if (row.file_url) {
        window.open(row.file_url, '_blank')
      } else {
        this.$message.warning('暂无证书文件')
      }
    },
    
    // 下载证书
    downloadCert(row) {
      if (row.file_url) {
        const link = document.createElement('a')
        link.href = row.file_url
        link.download = row.cert_name || '证书文件'
        link.click()
      } else {
        this.$message.warning('暂无证书文件')
      }
    },
    
    // 编辑
    goEdit() {
      this.$router.push({
        path: '/proxyEmployeeForm',
        query: { id: this.employeeId }
      })
    },
    
    // 返回列表
    goBack() {
      this.$router.push('/proxyEmployeeList')
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}

// 信息区块样式
.info-section {
  margin-bottom: 28px;
  
  .section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    padding-left: 8px;
    border-left: 3px solid #1677ff;
    
    i {
      font-size: 16px;
      color: #1677ff;
    }
    
    span {
      font-size: 15px;
      font-weight: 600;
      color: #1f2d3d;
    }
    
    .add-btn {
      margin-left: auto;
      border-radius: 20px;
    }
  }
}

// 描述列表样式
.info-descriptions {
  ::v-deep .el-descriptions-item__label {
    background: #f8f9fc;
    font-weight: 500;
    color: #606266;
    width: 130px;
  }
  
  .name-text { font-weight: 600; color: #1f2d3d; }
  .id-card { font-family: monospace; color: #1677ff; }
  .dept-name { color: #e6a23c; }
  .time-text { font-size: 12px; color: #8c8f98; }
}

// 表格样式
.table-wrapper {
  margin-bottom: 20px;
  min-height: 200px;
  
  ::v-deep .el-table {
    border-radius: 12px;
    overflow: hidden;
    
    th { background: #fafbfc !important; font-weight: 500; }
    td { border-bottom: 1px solid #f0f0f0; }
  }
}

.expired { color: #ff4d4f; }

// 空状态样式
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #c0c4cc;
  
  i { font-size: 64px; }
  p { margin-top: 16px; font-size: 14px; }
  .el-button { margin-top: 20px; border-radius: 20px; }
}

// 底部按钮样式
.form-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  
  .el-button {
    border-radius: 24px;
    padding: 10px 28px;
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    &:hover { background: #4096ff; border-color: #4096ff; }
  }
}
</style>